import EntityChallengeBulkDelete from './EntityChallengeBulkDelete';

export default EntityChallengeBulkDelete;
